import { baseSeriesMark } from "../base/constant";

export const funnelSeriesMark = Object.assign(Object.assign({}, baseSeriesMark), {
    funnel: {
        name: "funnel",
        type: "polygon"
    },
    transform: {
        name: "transform",
        type: "polygon"
    },
    transformLabel: {
        name: "transformLabel",
        type: "text"
    },
    outerLabel: {
        name: "outerLabel",
        type: "text"
    },
    outerLabelLine: {
        name: "outerLabelLine",
        type: "rule"
    }
});
//# sourceMappingURL=constant.js.map
